<template>
	<footer class="flex justify-center footer-box">
		<div v-if="show1" class="robot" style="z-index: 11111111111;">
			<newRobot></newRobot>
		</div>
		<div style="position: relative;">
			<div class="shuziren" style="z-index:2147483646;">
				<div v-if="!show1">
					<div class="robotButton" @click="clicktrue()" >
						<div class="shuzirenRound">
							<img  class="shuzirenRoundImg" src="~@/assets/images/exposition/humansmall.png" alt="">
						</div>
						<div class="shuzirenIcon1">
							<img class="shuzirenIconImg" v-if="show1===false"
								src="~@/assets/images/exposition/minimize.png" alt="">
							<img class="shuzirenIconImg" v-if="show1===true"
								src="~@/assets/images/exposition/maximize.png" alt="">
						</div>

					</div>
				</div>
			</div>
			<div class="footer-bg flex justify-center">
				<div v-for="(item, i) in footerList" :key="'footerList' + i" class="footer-item"
					@click="goWeb(item.url, i)">
					<img class="img" :src="i == atIndex ? item.atIcon : item.icon" alt="" />
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	import newRobot from "@/views/exposition/components/robat/index.vue";
	let chdWhiteList = ['changingElectricity', 'changingElectricityMerge', 'powerStation', 'batteryCompartment',
		'batteryInfo', 'chonghuan-station'
	]
	let carWhiteList = ['vehicles', 'newVehiclesProvince', 'newVehiclesProvince', 'newVehicleControl', 'singleVehicle',
		'singlezhongka', 'carBatteryInfo'
	]
	export default {
		components: {
			newRobot
		},
		mounted() {
			this.$EventBus.$on('clicktrue2', (show2) => {
				// console.log(show2, 'this.show1this.show1this.show2222222222222222222222')
				if (show2) {
					this.show1 = true;
				} else {
					this.show1 = false;
				}
			})
		},
		create() {
		},
		data() {
			return {
				show1: false,
				// index: 0,
				footerList: [{
						url: '/energyStorage',
						icon: require('@/assets/images/exposition/footer-6.png'),
						atIcon: require('@/assets/images/exposition/footer-6-at.png')
					},
					{
						url: '/Intelligence',
						icon: require('@/assets/images/exposition/footer-5.png'),
						atIcon: require('@/assets/images/exposition/footer-5-at.png')
					},
					{
						url: '/exposition',
						icon: require('@/assets/images/exposition/footer-1.png'),
						atIcon: require('@/assets/images/exposition/footer-1-at.png')
					},
					{
						url: '/changingElectricity',
						icon: require('@/assets/images/exposition/footer-2.png'),
						atIcon: require('@/assets/images/exposition/footer-2-at.png')
					},
					{
						url: '/vehicles',
						icon: require('@/assets/images/exposition/footer-3.png'),
						atIcon: require('@/assets/images/exposition/footer-3-at.png')
					},
					{
						url: '/dummy',
						icon: require('@/assets/images/exposition/footer-4.png'),
						atIcon: require('@/assets/images/exposition/footer-4-at.png')
					},

				]
			}
		},
		computed: {
			atIndex() {
				let index = 0
				let routeName = this.$route.name

				if (routeName == 'exposition') {
					index = 2
				}
				if (chdWhiteList.includes(routeName)) {
					index = 3
				}
				if (carWhiteList.includes(routeName)) {
					index = 4
				}
				if (routeName == 'dummy') {
					index = 5
				}
				if (routeName == 'xunidianchang2') {
					index = 5
				}
				if (routeName == 'energyStorage') {
					index = 0
				}
				if (routeName == 'Intelligence') {
					index = 1
				}

				return index
			}
		},
		methods: {
			goWeb(path, i) {
				// if(i == this.index) return
				this.index = i
				let localName = localStorage.getItem('exposition::pathName')
				console.log(this.$route.name,'console.log(this.$route.name)')
				if (path.includes('changingElectricity')) {
					path = localName ? '/' + localName : path
				}
				// window.location.reload ()
				this.$router.push({
					path,
					query: {}
				})
			},
			clicktrue() {
				this.show1 = !this.show1;
				console.log(this.show1, 'this.show1')
				this.$EventBus.$emit('clicktrue', this.show1)
				
			},
		}
	}
</script>

<style lang="scss" scoped>
	.footer-box {
		position: fixed;
		// width: 100%;
		width: 3593px;
		bottom: 0;
		z-index: 11;
		left: 50%;
		transform: translate(-50%, 0);

		@keyframes breath_light {
			0% {
				filter: brightness(90%);
			}

			50% {
				filter: brightness(140%);
			}

			100% {
				filter: brightness(90%);
			}
		}

		.shuziren {
			position: absolute;
			bottom: 33px;
			left: 71%;
			width: 270px;
			height: 80px;

			.robotButton {
				z-index: 1000009;
				display: flex;
				// position:absolute;
				// left:8px;
				// bottom:200px;
				width: 160px;
				height: 80px;
				background-image: url("~@/assets/images/exposition/shuzirenBtn.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;

				.shuzirenRound {

					border-radius: 50%;
					width: 80px;
					height: 80px;
					background-image: url("~@/assets/images/exposition/shuzirenRound.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
                    .shuzirenRoundImg{
						display: block;
						width: 75px;
						height: 75px;
						border-radius: 50%;
					} 
				}
				.shuzirenIcon1 {
					margin-top: 15px;
					margin-left: 6px;

					.shuzirenIconImg {
						display: block;
						width: 45px;
						height: 45px;
					}
				}
			}
		}

		.footer-bgBox {
			width: 3593px;
			height: 118px;
			// background: radial-gradient( rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
			// background: radial-gradient( rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
			// background: linear-gradient(to bottom right, #FFA500, #FF1493);
			background-image: radial-gradient(circle at 50% 100%, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
		}

		.footer-bg {
			animation: breath_light 3s ease infinite;
			width: 2447px;
			height: 212px;
			background: url('~@/assets/images/exposition/footer.png') no-repeat center center;
			background-size: 100% 100%;
			padding-top: 10px;

			.footer-item {
				transition: all .5s;
				width: 150px;
				height: 144px;
				margin: 0 5px;
				cursor: pointer;
				position: relative;

				&:hover {
					transform: scale(1.2) translate(0, -10%);
				}

				.img {
					position: absolute;
					top: 10px;
					width: 100%;
					height: 100%;
				}
			}
		}
	}
</style>